import {inject, Injectable} from '@angular/core';
import {SnackbarService} from "../../../../../services/snackbar.service";
import {ButtonRecordValue, RecordData} from "../../../../../types/records-table.types";
import {ErrorService} from "../../../../../services/error.service";
import {classIconConfig} from "../configs/modal-record-table-item-config";
import {ModalItemPasteStateService} from "./modal-item-paste-state.service";
import {GetClassIconParams} from "../types/modal-record-table-item.types";
import {Router} from "@angular/router";
import {OpenFilesViewerModalParams} from "../../../../../types/file.types";
import {
  advertisementStatisticsResourceType
} from "../../../../modals/advertisement-statistics-modal/configs/advertisement-statistics-modal-config";
import {EditorTextModalDialogData} from "../../../../modals/editor-text-modal/types/editor-text-modal.types";
import {resources} from "../../../../../models/resource/resources";

@Injectable({
  providedIn: 'root'
})
export class ModalRecordTableItemService {
  private snackbarService: SnackbarService = inject(SnackbarService);
  private errorService: ErrorService = inject(ErrorService);
  private modalItemPasteStateService: ModalItemPasteStateService = inject(ModalItemPasteStateService);
  private router: Router = inject(Router);

  public classIcon(getClassIconParams: GetClassIconParams): string {
    const { key, recordData } = getClassIconParams;
    switch (key) {
      case 'contentPaste':
        return this.modalItemPasteStateService.isModalItemPasteStateByRecordId(Number(recordData.id)) ?
          'content_paste_go' :
          'content_paste';
      default:
        return classIconConfig[key] || '';
    }
  }

  public async handleSaveNoteFile(recordData: RecordData): Promise<void> {
    const recordId = Number(recordData.id);
    this.modalItemPasteStateService.setIsModalItemPasteState(recordId);
    const isModalItemPaste = this.modalItemPasteStateService.isModalItemPasteStateByRecordId(recordId);
    this.snackbarService.showMessage({
      type: 'info',
      message: isModalItemPaste ?
        'Режим вставки активен - нажмите Ctrl+V для загрузки файлов' :
        'Режим вставки отключён'
    });
  }

  public getFilePaste(event: ClipboardEvent) {
    const files = Array.from(event.clipboardData?.items || [])
      .filter(item => item.kind === 'file')
      .map(item => item.getAsFile())
      .filter(Boolean) as Array<File>;

    !files.length && this.errorService.showErrorMessage('Нет файлов для загрузки!');

    return files;
  }

  public openProductCardPage(productCardId: number): void {
    const urlTree = this.router.createUrlTree(['/records/product-card', productCardId]);
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');
  }

  public setOpenFilesViewerModalParams(columnParamKey: string, recordData: RecordData): OpenFilesViewerModalParams {
    const isInitialVideoModalKey = columnParamKey === 'initialVideo';
    const id = Number(recordData['recordCalendarId']) || Number(recordData.id);

    return {
      title: isInitialVideoModalKey ? 'Первичное видео' : 'Финальное видео',
      key: isInitialVideoModalKey ? 'INITIAL_VIDEO' : 'FINAL_VIDEO',
      recordId: id,
      parentPath: advertisementStatisticsResourceType.path,
      recordCalendarId: id,
      isEditMode: false,
      noUploadComponent: true
    };
  }

  public setTextDialogData(recordData: RecordData, modalKey: string): EditorTextModalDialogData {
    const content = (recordData[modalKey] as ButtonRecordValue).value;
    return {
      path: resources['advertisement-integrations'].path,
      modalName: `Комментарий оценщика видео`,
      recordId: Number(recordData.id) || Number(recordData['recordCalendarId']),
      key: 'videoFeedback',
      fieldLabel: 'Комментарий',
      content: content || '',
      noEdit: false
    };
  }
}
